import { Stack, Typography } from "@mui/material";

import { HubHookFormInput } from "../HubHookFormInput";
import { UsersHookFormSelect } from "../UsersHookFormSelect";

import { StyledCardRow } from "./styles";

const sx = {
  flexDirection: "row",
  gap: "10px",
  height: "100%",
  width: "100%",
  alignItems: "center",
};


export const CheckerInfo = ({ disabled, locationId = 1 }) => (
  <StyledCardRow sx={{ flexGrow: 0, borderTop: 0}}>
    <Stack sx={sx}>
      <Typography variant="subtitle2">Approver:</Typography>
      <UsersHookFormSelect
        name="userId"
        formControlProps={{ sx: { width: "150px !important" } }}
        disabled={disabled}
        rendered={false}
        locationId={locationId}
        useSelect
        hideLabel
        required
      />
    </Stack>
    <Stack sx={sx} justifyContent="center">
      <Typography variant="subtitle2" noWrap>
        Cartons/Packages:
      </Typography>
      <HubHookFormInput
        name="boxes"
        placeholder="Total Packages"
        formControlProps={{ sx: { width: "75px !important" } }}
        disabled={disabled}
        isNumber
        required
      />
    </Stack>
    <Stack sx={sx} justifyContent="end">
      <Typography variant="subtitle2" noWrap>
        Weight (lbs):
      </Typography>
      <HubHookFormInput
        name="weight"
        placeholder="Total Weight"
        formControlProps={{ sx: { width: "75px !important" } }}
        disabled={disabled}
        endAdornment="lbs"
        isDecimal
        required
      />
    </Stack>
  </StyledCardRow>
);
